import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  connect() {
    document.querySelector("#modalOnline").showModal();
    $("html").addClass("is-fixed");
  }
}
